import React from 'react'
import PropTypes from 'prop-types'
import styles from './hero.module.css'
import Image from 'gatsby-image'
import Nav from './nav'
import MasterForm from './form/master-form'
import { useStaticQuery, graphql, Link } from 'gatsby'

const Hero = ({ headline, useH1, hideForm }) => {
  return (
    <div className={styles.container}>
      <Nav />
      <Link to={'/'}>
        <Image
          fluid={useSiteLogo().childImageSharp.sizes}
          className={styles.logo}
          alt="SwitchPal Logo"
        />
      </Link>
      {(useH1 && <h1 className={styles.headline}>{headline}</h1>) || (
        <p className={styles.headline}>{headline}</p>
      )}
      {!hideForm && <MasterForm />}
    </div>
  )
}

Hero.propTypes = {
  headline: PropTypes.string.isRequired,
  useH1: PropTypes.bool,
  hideForm: PropTypes.bool,
}

export const useSiteLogo = () => {
  const { logo } = useStaticQuery(
    graphql`
      query {
        logo: file(absolutePath: { regex: "/logo-vertical.png/" }) {
          childImageSharp {
            sizes(maxWidth: 310) {
              ...GatsbyImageSharpSizes_noBase64
            }
          }
        }
      }
    `,
  )
  return logo
}

export default Hero
